export const GET_COUNTRY_URL = "/api/country";
export const GET_STATE_URL = "/api/state/";
export const GET_CITY_URL = "/api/city/";